import { SET_DATA, SET_LOADING } from 'modules/AccountsMarketplace/Product/types'
import { updateObject } from 'utils/updateObject'

const initialState = {
  loading: true,
  description: '',
  id: 0,
  name: '',
  category_id: 0,
  price: 0,
  amount: 0,
}

const setProduct = (state, { payload }) =>
  updateObject(state, {
    ...payload,
    loading: false,
  })

const setLoading = (state, { payload }) => updateObject(state, payload)

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_DATA:
      return setProduct(state, action)
    case SET_LOADING:
      return setLoading(state, action)
    default:
      return state
  }
}
